import React from 'react'
import styled from 'styled-components'
import { assetPrefix } from 'config/env_config'
import Terms from 'components/terms'
import PageContainer from 'components/pageContainer'
import { MEDIA, scrollTop } from 'utils'

const { MOBILE, MOBILE_UP, DESKTOP_UP } = MEDIA

const PolicyContainer = styled(PageContainer)`
  @media screen and ${MOBILE} {
    margin: 0 28px;
  }
`

const Title = styled.div`
  font-size: 38px;
  font-family: var(--primary-font);
  font-weight: bold;
  color: var(--cobasi-blue);
  margin-top: 30px;
  margin-bottom: 10px;

  @media screen and ${MOBILE_UP} {
    margin-bottom: 23px;
  }
`

const BackToTopButtonContainer = styled.div`
  position: fixed;
  top: 50%;
  width: 47px;
  height: 47px;
  background: var(--cobasi-blue-light-4);
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 2px;
  cursor: pointer;
  left: calc(100vw - 66px);

  @media screen and ${DESKTOP_UP} {
    left: 80%;
    width: 31px;
    height: 31px;
  }
`

const ArrowTop = styled.div`
  width: 37px;
  height: 29px;
  transform: rotate(180deg);
  background: url(${assetPrefix}/static/icons/arrow.svg) no-repeat;
  background-size: 25px 14px;

  @media screen and ${DESKTOP_UP} {
    width: 23px;
    height: 19px;
    background-size: unset;
  }
`

const BackToTopButton = () => (
  <BackToTopButtonContainer title='Voltar ao topo' onClick={scrollTop}>
    <ArrowTop />
  </BackToTopButtonContainer>
)

const PoliticaUsoServicos = () => {
  return (
    <PolicyContainer maxWidth='790px' backPosition='absolute'>
      <Title>Política de Uso</Title>
      <Terms hideButtons />
      <BackToTopButton />
    </PolicyContainer>
  )
}

export default PoliticaUsoServicos
